import React from 'react';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import App from 'src/App';

import 'src/styles/global.css';

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: 'https://9babc3d06bcf9ffcc15c0037dd90938a@o96783.ingest.us.sentry.io/4508839442055168',
        integrations: [],
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
    });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
